'use strict';

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export const NOTIFICATIONS$: Subject<LKNotification> = new Subject();
const DEFAULT_TIMEOUT = 3000;

@Injectable()
export class NotificationService {

  constructor() {
  }

  public static timer: number = DEFAULT_TIMEOUT;

  /**
   * Show an "error" notification
   */
  public static error(
    message: string,
    buttons?: Array<{label: string; action: () => any}>,
    timeout?: number
  ) {
    NotificationService.timer = timeout || DEFAULT_TIMEOUT;
    NOTIFICATIONS$.next(new LKNotification('error', message, buttons, timeout));
  }

  /**
   * Show a "warning" notification
   */
  public static warning(
    message: string,
    buttons?: Array<{label: string; action: () => any}>,
    timeout?: number
  ) {
    NotificationService.timer = timeout || DEFAULT_TIMEOUT;
    NOTIFICATIONS$.next(new LKNotification('warning', message, buttons, timeout));
  }

  /**
   * Show a "info" notification
   */
  public static info(
    message: string,
    buttons?: Array<{label: string; action: () => any}>,
    timeout?: number
  ) {
    NotificationService.timer = timeout || DEFAULT_TIMEOUT;
    NOTIFICATIONS$.next(new LKNotification('info', message, buttons, timeout));
  }

  /**
   * Show a "success" notification
   */
  public static success(
    message: string,
    buttons?: Array<{label: string; action: () => any}>,
    timeout?: number
  ) {
    NotificationService.timer = timeout || DEFAULT_TIMEOUT;
    NOTIFICATIONS$.next(new LKNotification('success', message, buttons, timeout));
  }
}

export class LKNotification {
  public type: 'info' | 'warning' | 'error' | 'success';
  public message: string;
  public buttons: Array<{label: string; action: () => any}>;
  public timeout: number;

  constructor (
    type: 'info' | 'warning' | 'error' | 'success',
    message: string,
    buttons?: Array<{label: string; action: () => any}>,
    timeout?: number
  ) {
    this.type = type;
    this.message = message;
    this.buttons = buttons;
    this.timeout = timeout;
  }
}


